import { useState, useCallback } from 'react';

/**
 * Simple single-field ordering string state (e.g. 'name' / '-name') shared by the
 * warehouses Product/StockItem list pages, plus the .table-sort header class helper.
 */
export function useSortOrdering(initialOrdering) {
  const [ordering, setOrdering] = useState(initialOrdering);

  const toggleOrder = useCallback((field) => {
    setOrdering((current) => (current === field ? `-${field}` : current === `-${field}` ? field : field));
  }, []);

  const getSortClass = useCallback((field) => {
    const base = 'table-sort d-flex justify-content-between';
    if (ordering.replace('-', '') !== field) return base;
    return `${base} ${ordering.startsWith('-') ? 'desc' : 'asc'}`;
  }, [ordering]);

  return { ordering, setOrdering, toggleOrder, getSortClass };
}
